<template>
  <div>
    <div>
      <v-layout wrap class="mt-3">
        <v-flex xs6 class="pt-2">
          <i class="fab fa-facebook-square mr-2" />
          {{ $t('connect_event_conversion') }}
        </v-flex>
        <v-flex xs6>
          <div v-if="isFacebookConversionConnected" class="success--text pt-2 pl-2">
            {{ $t('connected') }}
            <a
              href="javascript:void(0);"
              outline
              color="primary"
              @click="disconnectEventConversion()"
            >
              ({{ $t('unlink') }})
            </a>
          </div>
          <div v-else>
            <v-btn color="primary" @click="openEventConversionDialog()">
              {{ $t('connect') }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-flex
      v-if="selectedBot.page_access_token && selectedBot.facebook_dataset_id"
      xs12
      class="arrow pa-4 my-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mb-1">
        Dataset Name:
        <span class="primary--text" style="font-weight: 500">{{
          eventConversionData.name || '-'
        }}</span>
      </div>
      <div>
        Dataset ID:
        <span class="primary--text" style="font-weight: 500">{{
          eventConversionData.id || '-'
        }}</span>
      </div>
    </v-flex>
    <v-flex xs12>
      {{ $t('event_conversion_remark_connect') }}
    </v-flex>

    <v-dialog v-model="showModalEventConversion" persistent max-width="400">
      <v-card>
        <div class="text-xs-center py-2">
          <h2 class="black--text">{{ $t('Create Dataset') }}</h2>
        </div>
        <v-card-text class="text-center">
          <div class="form-control">
            <input v-model="eventConversionPayload.name" type="text" :placeholder="$t('name')" />
          </div>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="closeEventConversionDialog">{{
              $t('cancel')
            }}</v-btn>
            <v-btn
              color="primary"
              :disabled="!eventConversionPayload.name"
              depressed
              @click="createEventConversion"
              >{{ $t('Save') }}</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import conversionApi from '@/api/conversion'

export default {
  data() {
    return {
      showModalEventConversion: false,
      eventConversionData: {
        id: null,
        name: null
      },
      eventConversionPayload: {
        name: ''
      },
      isConnectedConversion: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    })
  },
  created() {
    if (this.selectedBot.page_access_token && this.selectedBot.facebook_dataset_id) {
      this.getEventConversion()
    }
  },
  methods: {
    async getEventConversion() {
      try {
        const response = await conversionApi.getFacebookDataset({
          page_id: this.selectedBot.pageid
        })
        if (
          response.status === 200 &&
          response.data.result.data &&
          response.data.result.data.length
        ) {
          const [eventConversion] = response.data.result.data
          this.eventConversionData.id = eventConversion.id
          this.eventConversionData.name = eventConversion.name
        } else {
          this.eventConversionData.id = null
          this.eventConversionData.name = ''
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    async openEventConversionDialog() {
      this.showModalEventConversion = true
      this.eventConversionPayload.name = ''
    },
    async closeEventConversionDialog() {
      this.showModalEventConversion = false
      this.eventConversionPayload.name = ''
    },
    async createEventConversion() {
      try {
        this.$store.dispatch('loading')
        const response = await conversionApi.postFacebookDataset({
          page_id: this.selectedBot.pageid,
          name: this.eventConversionPayload.name
        })
        if (response.status === 200) {
          this.eventConversionData.id = response.data.result.facebook_dataset_id
          this.eventConversionData.name = this.eventConversionPayload.name
          this.isConnectedConversion = true
          await this.$store.dispatch('updateBotDetail')
          this.closeEventConversionDialog()
        } else {
          this.eventConversionData.id = null
          this.eventConversionData.name = ''
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async disconnectEventConversion() {
      try {
        this.$store.dispatch('loading')
        const response = await conversionApi.deleteFacebookDataset({
          page_id: this.selectedBot.pageid
        })
        if (response.status === 200) {
          this.eventConversionData.id = null
          this.eventConversionData.name = ''
          await this.$store.dispatch('updateBotDetail')
        }
        this.isConnectedConversion = false
      } catch (error) {
        console.log('error', error)
      } finally {
        this.$store.dispatch('loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/billing/FacebookEventConversion.vue